<div
  class="gateComponentsContainer"
  *appHasPermission="{
    permissions: [permissions.allPermissions.ASSET_COMPONENT_READ],
  }"
>
  <div class="widget flex flex-column gap-3 container p-3">
    <span> {{ "gate_components.import.title" | translate }}</span>
    <app-button buttonText="gate_components.import.start" (click)="onOpenImport()"></app-button>
  </div>
  @if (timeoutManufacturers()) {
    <div class="widget container flex justify-content-center align-items-center" id="manufacturerContainer">
      <app-timeout></app-timeout>
    </div>
  } @else if (loadingManufacturers()) {
    <div class="widget container flex justify-content-center align-items-center" id="manufacturerContainer">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    @if (manufacturers) {
      <ngx-simplebar class="list-wide-rows selectable widget" id="manufacturerContainer">
        <div class="list-grid">
          <div class="flex justify-content-between align-items-center">
            <span class="list-header">{{ "gate_components.manufacturers" | translate }}</span>
            <div class="flex gap-3">
              <app-svg-icon
                iconName="plus"
                iconColor="primary"
                class="pointer"
                style="margin-bottom: 0.5rem"
                (click)="onAddClick(gateCatalogItemTypes.MANUFACTURER)"
                *appHasPermission="{
                  permissions: [permissions.allPermissions.ASSET_COMPONENT_CREATE],
                }"
              ></app-svg-icon>
            </div>
          </div>

          @if (manufacturers.length > 0) {
            @for (manufacturer of manufacturers; track manufacturer.id) {
              <div
                class="list-item"
                [ngClass]="{
                  selected: manufacturer.selected,
                  'selected-bg': manufacturer.selected,
                }"
                (click)="selectManufacturer(manufacturer)"
              >
                <div class="list-item-content">
                  <span>{{ manufacturer.label }}</span>

                  <div class="btn-container">
                    <app-svg-icon
                      *appHasPermission="{
                        permissions: [permissions.allPermissions.ASSET_COMPONENT_UPDATE],
                      }"
                      iconName="edit"
                      iconColor="primary"
                      iconSize="sm"
                      (click)="onEditClick(gateCatalogItemTypes.MANUFACTURER, manufacturer, $event)"
                    ></app-svg-icon>

                    <app-svg-icon
                      *appHasPermission="{
                        permissions: [permissions.allPermissions.ASSET_COMPONENT_DELETE],
                      }"
                      iconName="trash"
                      iconColor="primary"
                      iconSize="sm"
                      (click)="onDeleteClick(gateCatalogItemTypes.MANUFACTURER, manufacturer, $event)"
                    ></app-svg-icon>
                  </div>
                </div>
              </div>
              @if (manufacturer.selected) {
                <div class="selected-arrow selected-bg">
                  <app-svg-icon iconName="arrow_right" iconColor="secondary" iconSize="sm"></app-svg-icon>
                </div>
              }
            }
          } @else {
            <span class="no-entries">{{ "common.no_entries" | translate }}</span>
          }
          <!-- <app-button
            class="add-btn"
            [buttonText]="translate.instant('gate_components.add_manufacturer')"
            (click)="onAddClick(gateCatalogItemTypes[0])"
          ></app-button> -->
        </div>
      </ngx-simplebar>
    }
  }
  @if (timeoutMakes()) {
    <div class="widget container flex justify-content-center align-items-center" id="makeContainer">
      <app-timeout></app-timeout>
    </div>
  }
  @if (loadingMakes()) {
    <div class="widget container flex justify-content-center align-items-center" id="makeContainer">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    @if (makes) {
      <ngx-simplebar [options]="{ autoHide: false }" class="list-wide-rows selectable widget" id="makeContainer">
        <div class="list-grid">
          <div class="flex justify-content-between align-items-center">
            <span class="list-header">{{ "gate_components.makes" | translate }}</span>
            <div class="flex gap-3">
              <app-svg-icon
                *appHasPermission="{
                  permissions: [permissions.allPermissions.ASSET_COMPONENT_CREATE],
                }"
                iconName="plus"
                iconColor="primary"
                class="pointer"
                style="margin-bottom: 0.5rem"
                (click)="onAddClick(gateCatalogItemTypes.MAKE)"
              ></app-svg-icon>
            </div>
          </div>

          @if (makes.length > 0) {
            @for (make of makes; track make.id) {
              <div
                class="list-item"
                [ngClass]="{
                  selected: make.selected,
                  'selected-bg': make.selected,
                }"
                (click)="selectMake(make)"
              >
                <div class="list-item-content">
                  <span>{{ make.label }}</span>

                  <div class="btn-container">
                    <app-svg-icon
                      *appHasPermission="{
                        permissions: [permissions.allPermissions.ASSET_COMPONENT_UPDATE],
                      }"
                      iconName="edit"
                      iconColor="primary"
                      iconSize="sm"
                      (click)="onEditClick(gateCatalogItemTypes.MAKE, make, $event)"
                    ></app-svg-icon>
                    <app-svg-icon
                      *appHasPermission="{
                        permissions: [permissions.allPermissions.ASSET_COMPONENT_DELETE],
                      }"
                      iconName="trash"
                      iconColor="primary"
                      iconSize="sm"
                      (click)="onDeleteClick(gateCatalogItemTypes.MAKE, make, $event)"
                    ></app-svg-icon>
                  </div>
                </div>
              </div>
              @if (make.selected) {
                <div class="selected-arrow selected-bg">
                  <app-svg-icon iconName="arrow_right" iconColor="secondary" iconSize="sm"></app-svg-icon>
                </div>
              }
            }
          } @else {
            <span class="no-entries">{{ "common.no_entries" | translate }}</span>
          }

          <!-- <app-button
            class="add-btn"
            [buttonText]="translate.instant('gate_components.add_make')"
            (click)="onAddClick(gateCatalogItemTypes[1])"
          ></app-button> -->
        </div>
      </ngx-simplebar>
    }
  }
  @if (timeoutArticles()) {
    <div class="widget container flex justify-content-center align-items-center" id="articleContainer">
      <app-timeout></app-timeout>
    </div>
  } @else if (loadingArticles()) {
    <div class="widget container flex justify-content-center align-items-center" id="articleContainer">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    @if (articles) {
      <ngx-simplebar
        [options]="{ autoHide: false }"
        class="list flex flex-column widget full-page-widget"
        id="articleContainer"
      >
        <div class="flex justify-content-between" style="padding-left: 1rem">
          <span class="list-header">{{ "gate_components.articles" | translate }}</span>
          <div class="flex gap-3">
            <app-svg-icon
              *appHasPermission="{
                permissions: [permissions.allPermissions.ASSET_COMPONENT_CREATE],
              }"
              iconName="plus"
              iconColor="primary"
              class="pointer"
              style="margin-bottom: 0.5rem"
              (click)="onAddClick(gateCatalogItemTypes.ARTICLE)"
            ></app-svg-icon>
          </div>
        </div>

        @if (articles.length > 0) {
          <p-table
            [columns]="articleTableCols"
            [value]="articles"
            class="transparent tableHeaderAlignTop"
            [scrollable]="true"
            scrollHeight="flex"
          >
            <ng-template #header let-columns>
              <tr>
                @for (col of columns; track col) {
                  <th class="font-size-sm font-normal">
                    {{ col.header | translate }}
                  </th>
                }
                <th></th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-rowData let-columns="columns">
              <tr>
                @for (col of columns; track col) {
                  <td>
                    @if (col.subField) {
                      @if (col.field === "componentType") {
                        {{
                          "gate_components.article_form.compontent_types." + rowData[col.field][col.subField]
                            | translate
                        }}
                      } @else {
                        {{ rowData[col.field][col.subField] }}
                      }
                    } @else if (
                      col.field === "loadChanges" ||
                      col.field === "operatingTime" ||
                      col.field === "maxLoadChanges" ||
                      col.field === "maxOperatingTime"
                    ) {
                      {{ rowData[col.field] ? (rowData[col.field] | number: "" : "de") : "" }}
                    } @else {
                      {{ rowData[col.field] }}
                    }
                  </td>
                }
                <td>
                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.ASSET_COMPONENT_UPDATE],
                    }"
                    class="pointer"
                    iconName="edit"
                    iconColor="primary"
                    iconSize="sm"
                    (click)="onEditClick(gateCatalogItemTypes.ARTICLE, rowData, $event)"
                  ></app-svg-icon>
                </td>
                <td>
                  <app-svg-icon
                    *appHasPermission="{
                      permissions: [permissions.allPermissions.ASSET_COMPONENT_DELETE],
                    }"
                    class="pointer"
                    iconName="trash"
                    iconColor="primary"
                    iconSize="sm"
                    (click)="onDeleteClick(gateCatalogItemTypes.ARTICLE, rowData, $event)"
                  ></app-svg-icon>
                </td>
              </tr>
            </ng-template>
          </p-table>
        } @else {
          <span class="no-entries">{{ "common.no_entries" | translate }}</span>
        }
      </ngx-simplebar>
    }
  }
</div>
